<template>
  <div class="lead-details-container bg-gray-100 dark-bg-custom">
    <div>
      <v-main style="padding: 0px;" class="bg-[#f7fafb] dark-bg-default">
        <div class="sticky-tabs">
          <v-col class="custom-tabs">
            <v-tabs 
              v-model="tabs" 
              align-with-title 
              :background-color="$vuetify.theme.currentTheme.backGroundColor"
              :color="$vuetify.theme.currentTheme.primary">
              <v-tab :ripple="false" v-for="(tab, index) in tabItems" :key="index" class="mr-12 ml-2" :color="$vuetify.theme.currentTheme.primary">
                {{ tab.name }}
              </v-tab>
              <v-tabs-slider color="#32D583"></v-tabs-slider>
            </v-tabs>
          </v-col>
        </div>
      </v-main>
      <div class="component-container">
        <component :is="currentTab" @refetchData="handleRefetchData" ref="configComponent" :receivedData="receivedData" :orgData="orgData"
          @configDataReceived="handleDataReceived"></component>
      </div>
    </div>
  </div>
</template>

<script>
import AppConfiguration from "./AppConfiguration.vue";
import OrgConfig from "./OrgConfigComponents";

export default {
  name: "ConfigurationComponent",
  layout: "Workforce/default",
  components: {
    AppConfiguration,
    OrgConfig,
  },
  data() {
    return {
      tabs: 0,
      tabItems: [
        {
          key: "OrgConfig",
          name: "Organization",
          component: "OrgConfig",
        },
        {
          key: "AppConfiguration",
          name: "Configure Employee Application",
          component: "AppConfiguration",
        },
      ],
      receivedData: null,
      orgData: null,
    };
  },
  computed: {
    currentTab() {
      return this.tabItems[this.tabs]?.component;
    },
  },
  methods: {
    handleRefetchData() {
      this.getConfig();
    },
    handleDataReceived(data) {
      this.receivedData = data;
    },
    async getConfig() {
      try {
        const response = await this.$axios.get("/workforce/org/config");

        const data = response.data?.config;

        this.receivedData = data;
      } catch (error) {
        console.error("Error fetching config:", error);
      }
    },
    async fetchOrg() {
      try {
        const result = await this.$axios.get("/organizations");
        this.orgData = result.data[0];
      } catch (error) {
        console.log(error?.response);
      }
    },
  },
  mounted() {
    this.getConfig();
    this.fetchOrg();
  },
};
</script>

<style scoped>
.v-tab:before {
  background-color: transparent;
}

.theme--light.v-tabs .v-tab:hover::before {
  opacity: 0;
}

.theme--light.v-tabs .v-tab--active:hover::before,
.theme--light.v-tabs .v-tab--active::before {
  opacity: 0;
}

.custom-tabs {
  padding-left: 0px;
}

.v-tab {
  font-size: 14px;
}
</style>
